import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';

/**
 * This action will get dispatched when message list option is loaded
 */

const loadMessageListOption = action('loadMessageListOption', () =>
    addDatapointConfig({ name: 'LoadMessageListOption' })
);

export default loadMessageListOption;
